const Blogs = [
    {
        title: "Exciting Milestone - 500 Users!",
        date: "2nd February 2025",
        mainImage: "/images/blog/500 users.png",
        slug: "500-users",
        images: [],
        intro: "We are delighted to share that Filmanize is now used by over 500 film creatives. A huge thank you to each and every one of you for your support, feedback, and trust in us.",
        content: <>
            <div>
                <p>Five years ago, we set out with an aim: to revolutionize affordable film pre-production management software. We've turned those ideas into reality, and this milestone shows that through hard work we're really making a positive impact on filmmakers' projects.</p>
                <p>If you haven't tried Filmanize yet, here's a few of our users' favourite features:</p>
                <ul className="marketing-ul">
                    <li><strong>AI Script Breakdown:</strong> Drastically reduce prep time.</li>
                    <li><strong>Automatic Call Sheets:</strong> Eliminate manual tasks and boost efficiency.</li>
                    <li><strong>Scheduling:</strong> Effortlessly gather crew and actor availability.</li>
                </ul>
                <p>And there's more to come!</p>
                <p>Looking ahead, we're eager to continue growing and enhancing Filmanize based on your invaluable feedback. Exciting new features are on the horizon, such as item commenting capabilities and direct messaging to all your crew members.</p>
                <p>As Filmanize was built on feedback, we'd love to hear from you. If you're already using Filmanize, share your experience in the comments. Not a user yet? Get started today and be part of our journey to the next milestone.</p>
                <p>Thanks to all our users once again - we couldn't have done it without you! Here's to many more milestones together! </p>
            </div>
        </>
    },
    {
        title: "Selected for San Sebastian",
        date: "26th September 2024",
        mainImage: "/images/blog/1727944583539.jpg",
        slug: "san-sebastian",
        images: [{
            original: "/images/blog/1727944579582.jpg",
            width: 451
        },
        {
            original: "/images/blog/1727944581847.jpg",
            width: 451
        }],
        intro: "We were honoured to have been selected to present Filmanize at the San Sebastian Film Festival Startup Challenge.",
        content: <>
            <div>
                <p>Among five European companies chosen, we had the exciting opportunity to showcase our products in front of a panel of esteemed judges. It was a privilege to highlight our innovative solutions and connect with influential leaders in the industry.</p>
            </div>
        </>
    }
];

export default Blogs